import axios from 'axios'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
// const HEADERS = {
//     'Content-Type': 'application/json'
// };

export async function postGetCities(uf, dispatch) {
    const AuthToken = 'Bearer '.concat(localStorage.getItem(process.env.REACT_APP_TOKENUSER));

    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/location/getcities',
        {
            "uf": uf
        },
        {
            headers: {
                'Authorization': AuthToken
            }
        }).then(response => {
            successPostGetCities(response, dispatch);
        }).catch(erro => {
            erroPostGetCities(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successPostGetCities(response, dispatch) {
    if (response.status === 200) {
        dispatch({
            type: 'SET_CIDADES',
            cidades: response.data
        })
    }
}

function erroPostGetCities(erro, dispatch) {
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Cidades',
        description: 'Houve um erro ao tentar recuperar as cidades'
    })
}